import { useContext } from 'react'

import MqttContext from './Context'

export default function useMqttContext() {
  const context = useContext(MqttContext)

  if (!context) {
    throw new Error('useMqttContext must be used within mqtt.MqttConnector')
  }

  return context
}
